import { z } from 'zod';
import { platformServiceConfigSchema } from '../configurations/PlatformServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderPlatformDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.PLATFORM]: platformServiceConfigSchema,
    }),
});

export { servicesProviderPlatformDataSchema };
//# sourceMappingURL=ServicesProviderPlatformData.js.map
